module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-text-lines-separated"
  }, [_c('div', {
    staticClass: "c-text-lines-separated__container u-block"
  }, _vm._l((_vm.textLinesSeparated), function(line, index) {
    return _c('div', {
      staticClass: "c-text-lines-separated__line u-block",
      class: [index > 0 ? _vm.subClasses : '']
    }, [_c('div', {
      staticClass: "c-text-lines-separated__line__inner u-relative u-inline-block"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(index < _vm.textLinesSeparated.length - 1 ? line + ' ' : line)
      }
    }), _vm._v(" "), (_vm.underligned) ? _c('span', {
      staticClass: "c-text-lines-separated__underline u-absolute u-pos-br u-fit-w u-bg--gray"
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "c-text-lines-separated__container--mobile"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textLinesSeparated.join(' '))
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9123b672"}!./src/scripts/components/app-text-lines-separated/template.html
// module id = 145
// module chunks = 0